// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1xzdP","ranges":"BmiRanges_ranges__3pKRV"};